import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { ErrorBanner } from "components/Error/ErrorBanner.tsx";
import Action from "core/action/Action";
import Spinner from "core/action/Spinner";
import { useCreateBulkUpdateExecution } from "hooks/createEntity";
import type React from "react";

export default function ExecuteBulkUpdateButton(props: {
  updateId: string;
  company_id: string;
  refresh?: () => any;
}): React.ReactElement {
  const create = useCreateBulkUpdateExecution(props.updateId, props.company_id);

  return (
    <>
      <Action
        onClick={() => {
          create.update(null).then(() => {
            props.refresh?.();
          });
        }}
        color={"brandLight"}
      >
        <Spinner alt={faPlay} spin={create.loading} className={"mr-2"} />
        Execute
      </Action>
      {create.error && <ErrorBanner error={create.error} />}
    </>
  );
}
